<app-select-site
  class="h-100 w-100"
  *ngIf="!this.sharedData?.selectedSite?.siteId; else dashboardDetail"
>
</app-select-site>

<ng-template #dashboardDetail>
  <ng-container *ngIf="!dashboardList">
    <div
      class="mx-sm-5 mx-xs-3 my-sm-5 my-xs-3 empty-record d-flex flex-column justify-content-center align-items-center h-100"
    >
      <div class="text-container">
        <div class="icon-container ml-auto mr-auto mb-3">
          <img src="assets/svg/ico-square-menu.svg" class="icon" />
        </div>
        <div class="text-center mb-4">
          <h2 class="heading">{{ 'NO_RECORD_IN_THIS_SITE' | translate }}</h2>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="dashboardList">
    <div class="container-fluid">
      <div class="dashboard">
        <div
          class="row center my-lg-5 mx-lg-5 my-xl-5 mx-xl-5 my-xl-5 mx-xl-5 my-md-3 mx-md-3 my-sm-2 mx-sm-2 my-xs-1 mx-xs-1"
        >
          <ng-container
            *ngFor="let dashboad of dashboardList?.defaultUserGroups"
          >
            <!-- dashboard user card start -->
            <ng-container
              *ngIf="
                dashboad?.userGroup === ('SHOWINGS' | translate) ||
                dashboad?.userGroup === ('MAINTENANCE' | translate) ||
                dashboad?.userGroup === ('PRIVATE_EVENTS' | translate)
              "
            >
              <div class="col-xl-4 col-md-6 mb-4">
                <app-dashboard-user-card
                  [user]="dashboad"
                ></app-dashboard-user-card>
              </div>
            </ng-container>
            <!-- dashboard user card end -->
          </ng-container>

          <!-- available unit card start -->
          <ng-container *ngFor="let dashboad of dashboardList?.availableUnits">
            <div class="col-xl-4 col-md-6 mb-4">
              <app-dashboard-unit-card
                [availableUnit]="dashboad"
                [siteId]="siteId"
              ></app-dashboard-unit-card>
            </div>
          </ng-container>
          <!-- available unit card end -->

          <!-- Shared Access card start -->
          <ng-container *ngFor="let dashboad of dashboardList?.sharedAccesses">
            <div class="col-xl-4 col-md-6 mb-4">
              <app-dashboard-share-access-card
                [shareAccess]="dashboad"
                [siteId]="siteId"
              >
              </app-dashboard-share-access-card>
            </div>
          </ng-container>
          <!-- Shared Access card end -->

          <!-- active issue card start -->
          <ng-container *ngFor="let dashboad of dashboardList?.activeIssues">
            <div class="col-xl-4 col-md-6 mb-4">
              <app-dashboard-device-card
                [activeIssues]="dashboad"
              ></app-dashboard-device-card>
            </div>
          </ng-container>
          <!-- active issue card end -->

          <!-- remaining invitation card start-->
          <ng-container>
            <div class="col-xl-4 col-md-6 mb-4">
              <app-dashboard-remaining-invitations-card
              [recurrentRevenue]="dashboardList.recurrentRevenue"
              ></app-dashboard-remaining-invitations-card>
            </div>
          </ng-container>
          <!-- remaining invitation card end-->
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
